import { buildURL, SharedImigixAndSourceProps } from 'react-imgix';

export type ImgixParams = SharedImigixAndSourceProps['imgixParams'];

const removeBeginningSlash = (uri: string) => uri.replace(/^\//, '');

export const buildHeImgixUrl = (
  uri: string,
  params?: ImgixParams,
  options?: SharedImigixAndSourceProps,
): string => buildURL(`${IMGIX_BASE}${removeBeginningSlash(uri)}`, params, options);

export const IMGIX_BASE = 'https://healthengine.imgix.net/';

export const buildHeImgixLQuipUrl = (src: string, params?: ImgixParams) =>
  buildHeImgixUrl(src, {
    blur: 100,
    px: 10,
    ...params,
  });
